import { Table } from "antd";
import { createStyles } from "antd-style";
import trans, { isRTL } from "../../../utils";
import { LoadingOutlined } from "@ant-design/icons";

const useStyle = createStyles(({ css, token }) => {
	const { antCls } = token;
	return {
		customTable: css`
			${antCls}-table {
				${antCls}-table-container {
					${antCls}-table-body,
					${antCls}-table-content {
						overflow: auto;
						scrollbar-width: thin;
						scrollbar-color: #eaeaea transparent;
						scrollbar-gutter: stable;
					}
				}
			}
		`,
	};
});

const AntdTable = ({
	columns,
	dataSource,
	loading,
	pageSize,
	totalItems,
	currentPage,
	onPageChange,
	onLimitChange,
	onTableChange,
	paginationValue,
	expandable,
	scrollY = 400,
	scrollX = false,
	rowSelection,
	onRow,
}) => {
	const { styles } = useStyle();

	const customSpinner = <LoadingOutlined style={{ color: "green" }} spin />;

	return (
		<Table
			className={`custom-antd-table ${styles.customTable}`} // Add manual className
			columns={columns}
			dataSource={dataSource}
			expandable={expandable}
			loading={{
				spinning: loading,
				tip: trans("Loading, please wait..."),
				indicator: customSpinner,
				style: { color: "#000000" },
			}}
			pagination={{
				current: currentPage,
				pageSize: pageSize,
				total: totalItems,
				onChange: onPageChange,
				onShowSizeChange: (current, size) => {
					onLimitChange(size);
				},
				showSizeChanger: true,
				disabled: paginationValue,
				hideOnSinglePage: paginationValue,
			}}
			scroll={{
				y: "calc(100vh - 334px)",
				x: scrollX ? "" : "max-content",
			}}
			rowKey="id"
			onChange={onTableChange} // Pass table changes (like sort) to parent
			direction={!isRTL ? "ltr" : "rtl"} // Set direction based on RTL setting
			tableLayout="fixed" // ✅ required for ellipsis
			rowSelection={rowSelection}
			onRow={onRow}
		/>
	);
};

export default AntdTable;
